import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Updates } from '../components/Updates';
import { WhyVanguard } from '../components/WhyVanguard';
import { Economy } from '../components/Economy';
import { Download } from '../components/Download';
import { Rankings } from '../components/Rankings';
import { News } from '../components/News';
import { Rewards } from '../components/Rewards';
import { ServerInfo } from '../components/ServerInfo';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { BackgroundMusic } from '../components/BackgroundMusic';
import { Registration } from '../components/Registration';
export function LandingPage() {
  return <div className="min-h-screen bg-darkerBlue text-white selection:bg-gold/30 selection:text-gold-light" data-id="element-760">
      <BackgroundMusic data-id="element-761" />
      <Navigation data-id="element-762" />
      <main data-id="element-763">
        <Hero data-id="element-764" />
        <Updates data-id="element-765" />
        <Features data-id="element-766" />
        <WhyVanguard data-id="element-767" />
        <Economy data-id="element-768" />
        <Download data-id="element-769" />
        <Rankings data-id="element-770" />
        <Registration data-id="element-771" />
        <News data-id="element-772" />
        <Rewards data-id="element-773" />
        <ServerInfo data-id="element-774" />
        <FAQ data-id="element-775" />
      </main>
      <Footer data-id="element-776" />
    </div>;
}